import {
  SALESFORCE_ADD_CONTACT,
  SALESFORCE_CONTACTS,
  SALESFORCE_EDIT_DELETE_CONTACT,
  SALESFORCE_QUOTA,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import salesforceContacts from "@shared/services/tour/mockedApis/supportContact/salesforceContacts.ts";
import salesforceQuota from "@shared/services/tour/mockedApis/supportContact/salesforceQuota.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import salesforceAddContact from "@shared/services/tour/mockedApis/supportContact/salesforceAddContact.ts";
import salesforceUpdateContact from "@shared/services/tour/mockedApis/supportContact/salesforceUpdateContact.ts";

export default {
  [SALESFORCE_CONTACTS]: () => salesforceContacts(),
  [SALESFORCE_QUOTA]: () => salesforceQuota(),
  [SALESFORCE_ADD_CONTACT]: (data) => salesforceAddContact(data),
  [SALESFORCE_EDIT_DELETE_CONTACT]: (data) => salesforceUpdateContact(data),
} satisfies TourUrlMapping;
